import React, { FC } from "react";
import dynamic from "next/dynamic";
import { ControllerRenderProps } from "react-hook-form";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const QVRDialogNextDate: FC<ControllerRenderProps> = (props) => {
  return (
    <Flatpickr
      options={{
        mode: "single",
        dateFormat: "m/d/Y",
        animate: true,
        disable: [
          function (date) {
            // return true to disable
            return date.getTime() < new Date(new Date().toLocaleDateString()).getTime();
          },
        ],
      }}
      value={moment(props.value).format("MM/DD/YYYY")}
      onChange={(value) => props.onChange(value[0])}
      style={
        {
          width: "261px",
          height: "35.25px",
          textAlign: "left",
          paddingLeft: "14px",
        } as any
      }
    />
  );
};

export default dynamic(() => Promise.resolve(QVRDialogNextDate), {
  ssr: false,
});
